import * as React from 'react';
import { Banner } from '@/components/ui/banner';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AlertCircleIcon, CheckCircle } from 'lucide-react';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface ConciergeBannerProps {
  isCollectionWorkflow?: boolean;
  email?: string;
  onEmailChange?: (email: string) => void;
}

export const ConciergeBanner: React.FC<ConciergeBannerProps> = ({
  isCollectionWorkflow = false,
  email = '',
  onEmailChange
}) => {
  const buttonLabel = isCollectionWorkflow
    ? 'Ready to Send'
    : 'Ready to Notify';
  const isValid = EMAIL_REGEX.test(email);
  const isInvalid = email && !isValid;

  return (
    <Banner
      tone="neutral"
      title="We will locate contact details for this institution."
      line={`Please review the letter and attachments below. Once you click ${buttonLabel} our team will verify the contact details and send this on your behalf within 24 hours.`}
    >
      <div className="border-border mt-3 flex flex-nowrap items-center space-y-1 gap-x-3 rounded-lg border px-3 py-2">
        <Label htmlFor="manual-email" className="shrink-0 pt-1 text-xs">
          Institution email address (optional)
        </Label>
        <div className="relative flex-1">
          <Input
            id="manual-institution-email"
            type="email"
            placeholder="contact@institution.com"
            value={email}
            onChange={(e) => onEmailChange?.(e.target.value)}
            className="h-6 pr-7 text-xs"
          />
          {isValid && (
            <CheckCircle className="text-success-subtle-foreground absolute top-1/2 right-2 h-3.5 w-3.5 -translate-y-1/2" />
          )}
          {isInvalid && (
            <AlertCircleIcon className="text-error-subtle-foreground absolute top-1/2 right-2 h-3.5 w-3.5 -translate-y-1/2" />
          )}
        </div>
      </div>
    </Banner>
  );
};
